import React from "react";
import { ProgramData, IOptionalStandard } from "@interfaces/Interfaces";
import OptionalStandardCheckbox from "@components/programs/OptionalStandardCheckbox";
import * as ProgramUtils from "@utils/programUtils";

interface OptionalStandardsSectionProps {
  program: ProgramData;
  standardsForSelectedRole: IOptionalStandard[];
  selectedStandards: IOptionalStandard[];
  onStandardsChange: (standards: IOptionalStandard[]) => void;
}

const OptionalStandardsSection: React.FC<OptionalStandardsSectionProps> = ({
  program,
  standardsForSelectedRole,
  selectedStandards,
  onStandardsChange,
}) => {
  if (!ProgramUtils.showOptionalStandardsInDetailsPage(program?.ID) || standardsForSelectedRole.length === 0) {
    return null;
  }

  const handleStandardClick = (standard: IOptionalStandard) => {
    const itemInSelectedItemsState = selectedStandards.find((s) => s.name === standard.name);

    if (itemInSelectedItemsState) {
      // remove item
      onStandardsChange(selectedStandards.filter((it) => it.name !== itemInSelectedItemsState.name));
    } else {
      // add item
      onStandardsChange([...selectedStandards, standard]);
    }
  };

  return (
    <div className="mb-6">
      <div className="editRolesHeader mt-6 mb-1.5">{"Select optional standards (Mandatory)"}</div>
      <div className="text-grey-90 text-acc-13px font-acc-400 mb-3">
        {
          "You are required to select 2 optional standards from your Primary Role that you would like to achieve (except for the Loggist role, which requires one optional standard)."
        }
      </div>
      {standardsForSelectedRole.map((standard) => {
        const itemInSelectedItemsState = selectedStandards.find((s) => s.name === standard.name);

        return (
          <OptionalStandardCheckbox
            key={standard.name}
            standard={standard}
            checked={itemInSelectedItemsState !== undefined}
            handleClick={() => handleStandardClick(standard)}
          />
        );
      })}
    </div>
  );
};

export default OptionalStandardsSection;
